import {SwapHoriz} from "@mui/icons-material";
import {IconButton, Stack, Typography} from "@mui/material";
import {useCallback, useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {addEstimation, auth, EstimationModel, formatCurrency} from "../../firebase/index.js";
import type {APXBaseOption, APXOptions} from "../../reusables/APXMoreMenuWithPopover.jsx";
import APXMoreMenuWithPopover from "../../reusables/APXMoreMenuWithPopover.jsx";
import {singleLineText} from "../../reusables/js/APXCrucialStyles.js";
import {red_900} from "../../reusables/js/APXTheme.js";
import AddNewEstimationBSL from "./AddNewEstimationBSL.jsx";
import {additionalHeaders, estKeys} from "./EstimationUtil.js";


export default function EstimationLayout({forKeys = false, item}: { forKeys?: boolean, item: EstimationModel }) {
	  const estimation: EstimationModel = item;
	  
	  // const {currentItem, currentOption, setCurrentItem, setCurrentOption, showBottomSheet, setShowBottomSheet} = useCurrentSelectedOption({});
	  const [showBottomSheet, setShowBottomSheet] = useState(false);
	  
	  const uid = useAuthState(auth)[0]?.uid;
	  
	  const estimationMenuOptions: APXOptions = {
			 edit: {
					label: "Edit",
					needsConfirmation: false,
					keepDisabled: false,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  setShowBottomSheet(true);
					}, [uid])
			 },
			 delete: {
					label: "Delete",
					needsConfirmation: true,
					keepDisabled: false,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  addEstimation(uid, estimation.estimationKey, null);
					}, [uid])
			 }
	  };
	  return (
				 <>
						<Stack p={0} spacing={1} alignItems={"center"} justifyContent={"stretch"} color={"#E6E6E6"}>
							  <Stack p={0.5} direction={"row"} justifyContent={"center"} alignItems={"center"} sx={{height: 36}}>
									 {
											forKeys ?
													  <Stack sx={{width: "100%"}}>
															 {Object.values(additionalHeaders).map((header) => (
																		<Typography key={header} align={"center"}
																						fontSize={8}
																						fontWeight={"bold"}
																						sx={singleLineText}
																		>
																			  {header}
																		</Typography>
															 ))}
													  </Stack>
													  :
													  <Stack sx={{width: "100%"}} direction={"row"} spacing={2} alignItems={"center"} justifyContent={"space-evenly"}>
															 <APXMoreMenuWithPopover options={estimationMenuOptions}
																							 onConfirmedOptionSelected={(option: APXBaseOption) => {
																									option && option.onClick();
																							 }}
																							 iconVertical={false}
															 />
															 <IconButton disabled><SwapHoriz/></IconButton>
															 {showBottomSheet && <AddNewEstimationBSL uid={uid} onClose={() => setShowBottomSheet(false)} estimation={estimation}/>}
													  </Stack>
									 }
							  </Stack>
							  <Stack justifyContent={"center"} sx={{width: "100%"}}>
									 {
											Object.entries(estimation).map(([key, value: string | number]) => (
													  key !== "estimationKey" &&
													  <Typography key={key} p={0.5} fontSize={{xs: 10, sm: 12}}
																	  sx={{
																			 backgroundColor: (key === estKeys.destination || key === estKeys.total) && red_900,
																			 textAlign: /*NOT->*/ !forKeys && "center",
																			 overflow: "hidden",
																			 textOverflow: "ellipsis",
																			 whiteSpace: "nowrap"
																	  }}
													  >
															 {
																	(key !== estKeys.destination && key !== estKeys.persons && key !== estKeys.nights) ?
																			  formatCurrency(value)
																			  :
																			  value
															 }
													  </Typography>
											))
									 }
							  </Stack>
						</Stack>
				 </>
	  );
}